"use strict";

function logN(base, num) {
  return Math.log(num) / Math.log(base);
}

function log10(n) {
  return Math.log(n) / Math.LN10;
}

module.exports = {
  logN: logN,
  log10: log10
};